// extracted by mini-css-extract-plugin
export var addViewLink = "_16-1";
export var availabilityIcon = "_16-16";
export var availabilitySelectionIcon = "_16-15";
export var backButton = "_16-2";
export var backIcon = "_16-z";
export var conversationCount = "_16-3";
export var dragHandle = "_16-5";
export var dropdown = "_16-e";
export var dropdownIcon = "_16-7";
export var dropdownOption = "_16-6";
export var dropdownTriangle = "_16-d";
export var expand = "_16-f";
export var folder = "_16-i";
export var folderItem = "_16-c";
export var icon = "_16-8";
export var iconRow = "_16-9";
export var image = "_16-a";
export var logo = "_16-b";
export var navContainer = "_16-h";
export var navigationFooter = "_16-g";
export var pageShell = "_16-0";
export var placeholderAvailable = "_16-11";
export var placeholderBox = "_16-14";
export var placeholderBusy = "_16-13";
export var placeholderUnavailable = "_16-12";
export var profile = "_16-k";
export var profileContainer = "_16-m";
export var profileDropdown = "_16-n";
export var profileImage = "_16-l";
export var profileMain = "_16-o";
export var profileSubtitle = "_16-q";
export var profileTitle = "_16-p";
export var reorderIcon = "_16-r";
export var sentLine = "_16-u";
export var settingsHeader = "_16-s";
export var sidenavTextColor = "_16-y";
export var spamLine = "_16-t";
export var subitemWithTag = "_16-4";
export var supportItems = "_16-j";
export var teamText = "_16-10";
export var viewLine = "_16-x";
export var viewLineButton = "_16-w";
export var viewLineButtons = "_16-v";